import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import logo from "../../assets/logo.svg";

interface Props {
	message?: string;
}

/**
 * AppLoadingView renders a "loading application" placeholder view.
 *
 * @param message the optional message rendered underneath GreenRouter logo
 * @returns       the placeholder view with GreenRouter logo and an optional message
 */
const AppLoadingView: FC<Props> = ({ message }) => {
	return (
		<Stack direction="column" alignItems="center" pt={10}>
			<img width={128} src={logo} alt="green-router-logo" />
			{message && <Typography variant="caption">{message}</Typography>}
		</Stack>
	);
};

export default AppLoadingView;
